import { ChangeEvent, RefObject } from 'react'
import { useFormikContext } from 'formik'

import { IUnSdgBase } from 'src/types'

interface ISdgIconInputProps {
  inputRef: RefObject<HTMLInputElement>
}

const SdgIconInput = ({ inputRef }: ISdgIconInputProps) => {
  const { setFieldValue } = useFormikContext<IUnSdgBase>()

  const handleChooseFile = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files && Array.from(e.target.files)
    if (files) {
      const urls = files.map((file) => {
        return new Promise((resolve) => {
          const fileReader = new FileReader()
          fileReader.onload = () => {
            if (fileReader.readyState === 2) {
              resolve(fileReader.result)
            }
          }
          fileReader.readAsDataURL(file)
        })
      }) as any

      Promise.all(urls).then((value) => {
        setFieldValue('image', { file: files[0], icon: value[0] })
      })
    }
  }

  return (
    <input
      ref={inputRef}
      accept="image/*"
      id={'image'}
      name={'image'}
      type="file"
      hidden
      onChange={handleChooseFile}
    />
  )
}

export { SdgIconInput }
